'use strict';

// require("babel-polyfill");
import '@babel/polyfill';


const TRANSITION_END = 'webkitTransitionEnd transitionend';
// const BREAK_POINT = 960;
import BREAK_POINT from './global';

var f = class{}



require("picturefill");
import 'jquery-inview'
import 'objectFitPolyfill';
import "jquery.scrollbar";
import anime from 'animejs'
import Rellax from 'rellax';
import ScrollHelper from './scrollhelper.js';
import ResizeHelper from './resize.js';
import SmoothScroll from './smoothScroll.js';
import Device from './device.js';
import 'url-polyfill';

const $body = $('body');
const $window = $(window);
// import Preload from "preload-it";

// import createjs from 'preload-js'
// var preload = new createjs.LoadQueue();
// preload.addEventListener("fileload", () => {
//   console.log('complete')
// });
// preload.loadFile("/video/TOP_01.mp4");


// module
// import Welcome from './welcome.js';
// const welcome = new Welcome();
// import Sketch from './sketch.js';
// const sketch = new Sketch();

// sketch.test();
// sketch.test();
// sketch.test();
// sketch.test();




// class Preloader{
//   constructor(){
//     this.preload = new createjs.LoadQueue();
//     this.checkCodecs();
//     this.listen();
//     this.parse();
//     // this.fetch();
//   }
//   checkCodecs(){
//
//     var media = document.createElement("video");
//     // this.canplaymp4 = media.canPlayType(`video/mp4; codecs="avc1.42E01E, mp4a.40.2"`)
//     this.canplaywebm = media.canPlayType(`video/webm; codecs="vp9"`)
//
//   }
//   parse(){
//     const preloadItemList = []
//     // img
//     const preloadImages = document.querySelectorAll('.preload-image');
//     for(const image of preloadImages){
//       preloadItemList.push(this.getImageSrc(image));
//     }
//
//     // video
//     const preloadVideos = document.querySelectorAll('.preload-video');
//     for(const video of preloadVideos){
//       preloadItemList.push(this.getVideoSrc(video));
//     }
//
//     this.fetch(preloadItemList);
//   }
//   fetch(preloadSrcList){
//     window.addEventListener('mousewheel', this.scrollCancell, {passive: false})
//     this.preload.loadManifest(preloadSrcList);
//   }
//   scrollCancell(e){
//     // console.log("mousewheel event")
//     e.preventDefault();
//     e.stopPropagation();
//     return false;
//   }
//   listen(){
//     const $progressbar = $('#progress-bar');
//     this.preload.addEventListener('progress', progress => {
//       $progressbar.width((progress.loaded * 100) + '%');
//     });
//     this.preload.addEventListener('error', () => {
//       window.removeEventListener('mousewheel', this.scrollCancell);
//     });
//     this.preload.addEventListener('complete', items => {
//       setTimeout(() => {
//         $body.addClass('loaded');
//         window.removeEventListener('mousewheel', this.scrollCancell);
//         $('#frame div').on(TRANSITION_END, function(e){
//           $(this).addClass('transition_end');
//         })
//       }, 500)
//       setTimeout(() => {
//         if($window.width() >= BREAK_POINT){
//           $body.addClass('menu-active');
//         }
//         $body.addClass('animated')
//       }, 1700);
//
//       $('.video-inview').each((index, el) => {
//         try{
//           el.load();
//         }catch(e){
//
//         }
//       })
//     });
//   }
//   getURLOrigin(path){
//     const origin = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");
//     return origin + path;
//   }
//   getImageSrc(image){
//     let imageSrc = '';
//     if(window.devicePixelRatio >= 2 && image.srcset){
//       // image.srcset.split(',').forEach(singleSrc => {
//       // });
//
//       for(const singleSrc of image.srcset.split(',')){
//         if(singleSrc.lastIndexOf('2x') != -1){
//           imageSrc = this.getURLOrigin(singleSrc.split(' ')[0]);
//         }
//       }
//     }else{
//       imageSrc = image.src;
//     }
//     return imageSrc;
//   }
//   getVideoSrc(video){
//     let videoSrc = '';
//     const sources = video.querySelectorAll('source');
//     for(let i = 0; i < sources.length; i+= 1){
//       const source = sources[i];
//       if(this.canplaywebm && source.getAttribute('type') === `video/webm; codecs="vp9"`){
//         videoSrc = source.src;
//         break;
//       }
//       else{
//         videoSrc = source.src;
//       }
//     }
//     return videoSrc;
//   }
// }

class SlideshowItem{
  constructor(element, parent){
    // console.log('item', element)
    this.element = element;
    this.parent = parent;
    this.index = null;
    this.next = null;
    this.ready = false;
    this.listen();
    // this.is_paused = false;
  }
  start(){
    // console.log('start')
    this.element.play();
    // this.element.classList.add('active');
    $(this.element).addClass('active');
    this.parent.onUpdateCurrentIndex(this.index)

    // console.log(this.index, 'this next load', this.next.element, this.next.element.load)
    this.next.element.load();
  }

  pause(){
    // if(!this.is_paused){
      // this.is_paused = true;
    this.element.pause();
    // }
  }
  resume(){
    // if(this.is_paused){
    this.element.play();
      // this.is_paused = false;
      // this.element.pause();
    // }
  }

  listen(){
    // console.log('listen')
    this.element.addEventListener('canplaythrough', this.onReady.bind(this));
    this.element.addEventListener('ended', this.playNext.bind(this));
  }
  onReady(){
    // console.log('onready')
    this.ready = true;
    this.element.removeEventListener('canplaythrough', this.onReady);
  }
  playNext(){
    // console.log(this.index, 'can playnext', this.next.ready)
    if(this.next.ready){
      // this.element.classList.remove('active');
      $(this.element).removeClass('active');
      this.element.removeEventListener('ended', this.playNext);
      this.next.start();
    }else{
      this.start();
    }
  }
  getVideoSrc(video){
    let videoSrc = '';
    const sources = video.querySelectorAll('source');
    for(let i = 0; i < sources.length; i+= 1){
      const source = sources[i];
      if(this.canplaywebm && source.getAttribute('type') === `video/webm; codecs="vp9"`){
        videoSrc = source.src;
        break;
      }
      else{
        videoSrc = source.src;
      }
    }
    return videoSrc;
  }

}


window.addEventListener('load', () => {

  $('#about-mv').css('visibility', 'visible');

  if(!document.querySelector('#about-mv')) return;

    // $('.circle-body').on('inview', (event, isInView) => {
    //   console.log(event)
    //   if(isInView){
    //     console.log('kv-images')
    //   }
    // });
    anime({
      targets: '#about-mv .circle-body',
      opacity: [0, 1],
      // round: 1,
      elasticity: 0,
      // delay: function(el, i) { return i * 600 },
      delay: 800,
      duration: 1400,
      easing: 'easeOutCubic',
      loop: false
    })

    // function animateAbout(){

    //
    const fadeText = anime({
      targets: '#about-mv .text',
      opacity: [0, 1],
      autoplay: false,
      elasticity: 0,
      delay: 3500,
      duration: 600,
      easing: 'easeOutCubic',
      loop: false
    })
    //
    const tl = anime.timeline({
      autoplay: false,
    });
        tl
          // line animation
          .add({
            targets: '.about-circle_line',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeOutCubic',
            duration: 1500,
            delay: 2000,
            elasticity: 0,
            delay: function(el, i) { return 600 + i * 250 },
            loop: false,
            complete: function(event){
              this.animatables.forEach((el) => {
                $(el.target).hide();
              })
            }
          })
          .add({
            targets: ['#about-circle_fill', '#about-circle_mask', '.about-circle_line_circle'],
            r: [190, 290],
            round: 1,
            elasticity: 0,
            delay: 0,
            duration: 1000,
            easing: 'easeOutCubic',
            loop: false,
            begin: function(){
              this.animatables.forEach((el) => {
                $(el.target).show();
              })
            },
          })
          .add({
            targets: '#about-mv .logo',
            opacity: [0, 1],
            // round: 1,
            elasticity: 0,
            delay: 500,
            duration: 800,
            begin: function(){
                $('#about-mv .arrow').addClass('active');
            },
            easing: 'easeOutCubic',
            loop: false
          })

    const aboutTrigger = new ScrollHelper(() => {
      const imageTop = $('.circle-body .image').offset().top;
      const threshold = $window.height() * 0.75;
      if(imageTop - threshold < $window.scrollTop()){
        tl.play();
        fadeText.play();
        aboutTrigger.destroy();
      }
    });

});
//
// try {
//   Typekit.load({
//     loading: function() {
//       console.log('typekit loading')
//       // JavaScript to execute when fonts start loading
//     },
//     active: function() {
//       console.log('typekit active')
//       // JavaScript to execute when fonts become active
//     },
//     inactive: function() {
//       console.log('typekit inactive')
//       // JavaScript to execute when fonts become inactive
//     }
//   })
// } catch(e) {}
        //
        // h=d.documentElement,
        // t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),
        // tk=d.createElement("script"),
        // f=false,
        // s=d.getElementsByTagName("script")[0],
        // a;
        //
        // h.className+=" wf-loading";
        // tk.src='https://use.typekit.net/'+config.kitId+'.js';
        // tk.async = true;
        // tk.onload = tk.onreadystatechange = function(){
        //   a = this.readyState;
        //   if(f||a&&a!="complete"&&a!="loaded")return;
        //   f = true;
        //   clearTimeout(t);
        //   try{
        //     Typekit.load(config)
        //   }catch(e){
        //
        //   }
        // };
        // s.parentNode.insertBefore(tk,s)


$(() => {

  // console.log(`'.video-overlay'`, $('.video-overlay').width() )
  // alert(`video-overlay = ` + $('.video-overlay').width() + 'w/' + $(window).width() )

  const $body = $('body');
  const $window = $(window);
  // const preloader = new Preloader();

  $body.addClass('ready');


  // -----------------------------------------------------------------------------
  // HEADER
  // languages menu
  const $lang = $('#menu-languages');
  $lang.hover((event) => {
    $lang.toggleClass('active', true)
  }, () => {
    $lang.toggleClass('active', false)
  });
  // $lang.find('a').each((index, el) => {
  //   const $el = $(el);
  //   $(el).on('mouseleave', (event) => {
  //     $(event.currentTarget).removeClass('blink');
  //   })
  //   $(el).on('click', (event) => {
  //     $(event.currentTarget).addClass('blink')
  //     location.href = event.currentTarget.href;
  //     setTimeout(() => {
  //     }, 300)
  //     event.preventDefault();
  //     event.stopPropagation();
  //     return false;
  //   });
  // });

  // menu
  $('#menu-btn').on('click', () => {
    $body.toggleClass('menu-active');
  });

  // bodyclass(scrolled)
  let windowHeight = window.innerHeight;
  const resizeHelper = new ResizeHelper(() => {
    windowHeight = window.innerHeight;
  })
  const stickyHeader = new ScrollHelper(function(){
    $body.toggleClass('scrolled', $(window).scrollTop() >= windowHeight);
  });

  // scroll label
  const scrollSign = new ScrollHelper(() => {
    if($(window).scrollTop() >= 50){
      scrollSign.destroy();
      $('#scroll').css('opacity', 0)
    }
  });

  // -----------------------------------------------------------------------------
  // INDEX

  // parallax

  if($('#index-about').length){
    const device_aboutphoto = new Device({
      breakpoint: BREAK_POINT
    });
    const rellax_aboutphoto = new Rellax('#index-about .about-photo', {
      center: true

    });
    device_aboutphoto.on('sp', (e) => {
      rellax_aboutphoto.options.speed = 0.5;
      rellax_aboutphoto.refresh();
    });
    device_aboutphoto.on('pc', (e) => {
      rellax_aboutphoto.options.speed = 1;
      rellax_aboutphoto.refresh();
    });
  }

  if($('.rellax').length){
    const rellax = new Rellax('.rellax', {
    });
  }

  const $aboutBlocks = $('.about-block');
  if($aboutBlocks.length){
    const rellaxBackgrounds = [];
    const rellaxImages = [];

    $aboutBlocks.each((index, el) => {
      const background = el.querySelector('.block-bg');
      const image = el.querySelector('.block-image');

      rellaxBackgrounds.push(
        new Rellax(background, {
          speed: -1.2,
          center: true,
          // wrapper: el,
          round: true,
          vertical: true,
          horizontal: false
        })
      );
      rellaxImages.push(
        new Rellax(image, {
          // speed: (function(){
          //   return $window.width() < BREAK_POINT ? 0.3 : 2;
          // })(),
          center: true,
          // wrapper: el,
          round: true,
          vertical: true,
          horizontal: false
        })
      );
    });


    const device = new Device({
      breakpoint: BREAK_POINT
    });
    device.on('sp', (e) => {
      rellaxBackgrounds.forEach(rellax => {
        rellax.options.speed = -0.75;
        rellax.refresh();
      });
      rellaxImages.forEach(rellax => {
        rellax.options.speed = 0.3;
        rellax.refresh();
      });
    });
    device.on('pc', (e) => {
      rellaxBackgrounds.forEach(rellax => {
        rellax.options.speed = -1.2;
        rellax.refresh();
      });
      rellaxImages.forEach(rellax => {
        rellax.options.speed = 2;
        rellax.refresh();
      });
    });
  }


  // -----------------------------------------------------------------------------
  // COMMON

  // scroll
  const smoothScroll = new SmoothScroll({
    breakpoint: BREAK_POINT,
    offset: {
      pc: 120,
      sp: 188
    }
  });
  smoothScroll.begin = () => {
    if($window.width() < BREAK_POINT){
      $body.removeClass('menu-active');
    }
  }

  // inview
  $('.inview').on('inview', (event, isInView) => {
    if(isInView){
      $(event.currentTarget).addClass('is-inview');
    }
  });


  // -----------------------------------------------------------------------------
  // PAGES

  // QA
  $('#qa').find('.qa-item').each(function(index, el){
    const $item = $(el);
    $item.find('.qa-title').on('click', () => {
      $item.toggleClass('active');
      $item.find('.qa-body').slideToggle('fast');
      return false;
    })
  });

  // Privacy
  $('.scrollbar-inner').scrollbar();



  objectFitPolyfill();


});
